export const LEGACY_COINS = [{
    "id": "5913643b-d495-4907-b2bb-4a752933574e",
    "name": "Bitcoin",
    "ticker": "BTC",
    "unicode_symbol": "₿",
    "decimals": 8,
    "price_provider": "Coinbase",
    "is_token": false,
    "chain": {
        "id": "ca7485c3-bcb8-4320-8750-9aad30258b5c",
        "name": "Bitcoin"
    },
    "fees": {
        "padding_percentage": 4,
        "fee_percentage": 25
    }
}]